import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("gomenu_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem("gomenu_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan, coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const rp = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

export const imgSrc = (u) => (u && u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const halfUp = (x) => Math.floor(x + 0.5);

export function computeTotals(subtotal, settings, dtype, dvalue) {
  const v = Number(dvalue || 0);
  const disc = Math.min(dtype === "persen" ? halfUp((subtotal * Math.min(v, 100)) / 100) : Math.floor(v), subtotal);
  const base = subtotal - disc;
  const service = halfUp((base * settings.service_percent) / 100);
  const tax = halfUp(((base + service) * settings.tax_percent) / 100);
  return { subtotal, discount: disc, service, tax, total: base + service + tax, service_percent: settings.service_percent, tax_percent: settings.tax_percent, discount_label: dtype === "persen" && disc ? `${v}%` : "" };
}

let TZ = 7;
export const setTz = (n) => { TZ = Number(n ?? 7); };
const shift = (iso) => new Date(new Date(iso).getTime() + TZ * 3600000);

export const fmtTime = (iso) =>
  iso ? shift(iso).toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit", timeZone: "UTC" }) : "-";

export const fmtDateTime = (iso) =>
  iso ? shift(iso).toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "UTC" }) : "-";

export const todayStr = () => shift(new Date().toISOString()).toISOString().slice(0, 10);

export const ROLE_LABEL = { admin: "Admin", kasir: "Kasir", waiter: "Waiter", checker: "Checker", dapur: "Dapur" };
export const ROLE_HOME = { admin: "/admin", kasir: "/kasir", waiter: "/waiter", checker: "/checker", dapur: "/dapur" };
export const METHOD_LABEL = { tunai: "Tunai", qris: "QRIS", kartu: "Kartu Debit/Kredit", transfer: "Transfer Bank" };
